export enum CurrencySymbol {
  USD = '$',
  EUR = '€',
  GBP = '£',
}

export enum Currency {
  USD = 'USD',
  EUR = 'EUR',
  GBP = 'GBP',
}

export const convertCurrencyToSymbol = (currency: Currency): CurrencySymbol => {
  switch (currency) {
    case Currency.EUR:
      return CurrencySymbol.EUR;
    default:
      return CurrencySymbol.USD;
  }
};
